module.exports = __webpack_public_path__ + "static/media/NoDataFound.603c1c97.png";